import { all, takeEvery, put, call } from "redux-saga/effects";
import { AUTH_LOGIN } from "./types";

import {
  loginUserFailure,
  loginUserRequest,
  loginUserSuccess,
} from "../auth/action";
import userLogin from "../../services/authServices";
import { getprofilesuccess } from "../Profilelogin/action";

export function* userLoginSaga({ payload }) {
  yield put(loginUserRequest());

  try {
    const result = yield call(userLogin, payload);
    console.log("result", result);
    if (result) {
      const values = {
        id: payload.values.id,
        sessionId: result.data?.sessionId,
        requestId: result.data?.requestId,
      };
      payload.dispatch(getprofilesuccess(values));
      yield put(loginUserSuccess(result));
      yield payload?.navigate("/dashboard");
    } else {
      yield put(loginUserFailure("unable to login"));
    }
  } catch (error) {
    yield put(
      loginUserFailure(
        error.response?.data?.response?.displayMsg || "unable to login"
      )
    );
  }
}

export default function* authSaga() {
  yield all([takeEvery(AUTH_LOGIN, userLoginSaga)]);
}
